window.onload = function() {
    // 检查页面是否包含 class "index-template"
      // document.querySelectorAll('.multicolumn__items .f-column').forEach(column => {
      //     const img = column.querySelector('img');
      //     const link = column.querySelector('a');
          
      //     if (img && link) {
      //         // 创建一个新的链接元素
      //         const anchor = document.createElement('a');
      //         anchor.href = link.href; // 设置链接地址
      //         anchor.className = 'image-link'; // 可选：添加一个类名以便于样式处理

      //         // 将 img 元素放入新的链接元素中
      //         anchor.appendChild(img.cloneNode(true)); // 使用 cloneNode 以保留事件和属性
      //         column.querySelector('.multicolumn-card__image').innerHTML = ''; // 清空原来的内容
      //         column.querySelector('.multicolumn-card__image').appendChild(anchor); // 添加新的链接元素
      //     }
      // });
    
   
  // const isMobile = window.innerWidth <= 768; 
  // if (!isMobile){
  //   // 获取所有的 .product__media-container 元素
  //   const mediaContainers = document.querySelectorAll('.product__media-list .product__media-container');
    
  //   // 遍历除了第一个元素以外的所有元素，并设置高度
  //   mediaContainers.forEach((container, index) => {
  //       if (index !== 0) { // 检查是否不是第一个元素
  //           container.style.height = '430px';
  //       } 
  //   });
    
  //    // 获取所有的 .product__media-container 中的 img 元素
  //   const images = document.querySelectorAll('.product__media-list .product__media-container img');
    
  //   // 遍历除了第一个元素以外的所有 img 元素，并设置高度
  //   images.forEach((image, index) => {
  //       if (index !== 0) { // 检查是否不是第一个元素
  //           image.style.height = '392px';
  //       }
  //   });
  // }
  
};

